import styles from './mock-kursadmin-service.module.scss';
import { useEffect, useState } from 'react';

const mockData = require("./kursadmin-mock-data.json");
/* eslint-disable-next-line */
export interface MockKursadminServiceProps { }

export const getMockData = (url: string) => {
  switch (url) {
    case 'registrations':
      const mockCaseRegistrations: any = mockData.registrations;
      return mockCaseRegistrations;
    case 'registration':
      const mockCaseRegistration: any = mockData.registration;
      return mockCaseRegistration;
    case 'room':
      const mockCaseRoom: any = mockData.room;
      return mockCaseRoom;
    case 'instructor':
      const mockCaseInstructor: any = mockData.instructor;
      return mockCaseInstructor;
    case 'duration':
      const mockCaseDuration: any = mockData.duration;
      return mockCaseDuration;
    case 'price':
      const mockCasePrice: any = mockData.price;
      return mockCasePrice;
    case 'level':
      const mockCaseLevel: any = mockData.level;
      return mockCaseLevel;
    case 'category':
      const mockCaseCategory: any = mockData.category;
      return mockCaseCategory;
    default:
      return null;
  }
}

export function useMockRequestHook(url: string, initialValue?: any, resultAdapter?: any, triggers?: Array<any>, onPromiseResult?: (data: any) => void) {
  const [data, setData] = useState<any>(initialValue || null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => getData(), triggers || []);
  const getData = () => {
    const requestPromise = makeGetRequest(url);
    setIsLoading(true);
    requestPromise.then((result: any) => {
      setIsLoading(false);
      setData(result);
      onPromiseResult && onPromiseResult(result);
    })
    return () => {
      setIsLoading(false);
    }
  }
  return { data, setData, isLoading, getData };
}

function makeGetRequest(url: string): any {
  return new Promise<any>((resolve, reject) => {
    setTimeout(() => {
      resolve(getMockData(url));
    }, 300);
  });
}
